import { render, staticRenderFns } from "./MyPrepaidCard.vue?vue&type=template&id=b3a00b22&"
import script from "./MyPrepaidCard.vue?vue&type=script&lang=js&"
export * from "./MyPrepaidCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports